// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__nYdEE","content":"style_content__7vZ8z","headers":"style_headers__Dt+h5","header":"style_header__zB33f","seedStep":"style_seedStep__0XTFO"};